import React, { useState } from "react";
import { Typography, Box, Grid2, ListItemText, useTheme, ListItem, ListItemIcon, List, Select, MenuItem } from "@mui/material";
import Highcharts from "highcharts/highstock";
import PieChart from "highcharts-react-official";
import { FaSquareFull } from "react-icons/fa6";
import { IoIosArrowDown } from "react-icons/io";
import { useGetContractorQuery } from "store/slices/apis/contractors";
import { useGetInvoiceAgeingAnalysisQuery } from "store/slices/apis/paymentTrackerSlice";
import { useParams } from "react-router-dom";

const AgingAnalysisPaymentTracker = () => {
    const theme = useTheme();
    const { projectId } = useParams();
    const [selectedCategory, setSelectedCategory] = useState("certification")
    const [selectedCategory2, setSelectedCategory2] = useState("")


    const { data, isLoading, error, refetch } = useGetInvoiceAgeingAnalysisQuery({
        projectId, ageingType: selectedCategory, vendor: selectedCategory2
    })

    const rawData = data?.data || [];

    const handleVendorClear = () => {
        setSelectedCategory2("");
        setTimeout(() => {
            refetch();  
        }, 0);
    };


    const ageingData = rawData.map((item, index) => {
        let name = item.ageingBucket;
        let y = item.invoiceCount;
        let color = "";

        if (item.invoiceCount <= 20) {
            color = "#3F766E";
        } else if (item.invoiceCount > 20 && item.invoiceCount <= 60) {
            color = "#EC5540";
        } else {
            color = "#FDCA40";
        }

        return {
            name,
            y,
            color,
        };
    });



    const { data: contractors } = useGetContractorQuery();
    const categories = contractors?.data?.map(item => item.name) || [];



    const options = {
        chart: {
            type: "pie",
            width: 300,
            height: 300,
            marginBottom: 30,
            marginTop: 0,
            marginRight: 0,
        },
        credits: {
            enabled: false,
        },
        tooltip: {
            formatter: function () {
                return `<b style='color: ${this.color}'>${this.name}</b>: ${this.y}`;
            },
        },
        title: {
            text: ""

        },
        plotOptions: {
            pie: {
                allowPointSelect: false,
                borderWidth: 0,
                borderRadius: 0,
                cursor: "pointer",
                dataLabels: {
                    enabled: false,
                },
                showInLegend: false,
                innerSize: 80,
            },
        },
        series: [
            {
                name: "",
                dataLabels: {
                    enabled: false,
                },
                color: "#006600",
                lineWidth: 1,
                data: ageingData
            },
        ],
    };

    return (
        <Box
            sx={{
                p: 2,
                width: "100%",
                height: { xs: "auto", md: "471px" },
                maxWidth: "100%",
                border: "1px solid #D8D8D8",
                mt: 0,
                borderRadius: "12px",
                overflow: "hidden",
                backgroundColor: "white",
            }}
        >
            <Grid2 container >
                <Grid2 size={{ xs: 12, md: 6 }}>
                    <Typography
                        variant="body"
                        sx={{
                            fontWeight: 500,
                            fontSize: "18px",
                            lineHeight: "100%",
                            letterSpacing: "-0.4px",
                            color: `${theme?.customSettings?.themeColor}`,
                        }}
                    >
                        Invoice Aging Analysis
                    </Typography>
                </Grid2>
                <Grid2 size={{ xs: 12, md: 6 }} sx={{ mt: { xs: 1.5, md: 0 } }}>
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: { xs: 'start', md: 'end' },
                            alignItems: "flex-start",
                            gap: 2,
                            width: "100%",
                            flexWrap: "wrap",
                        }}
                    >
                        <Box sx={{ position: 'relative', width: { xs: '100%', sm: '250px', md: '210px' }, }}>
                            <Select
                                displayEmpty
                                value={selectedCategory2 || ""}
                                onChange={(e) => setSelectedCategory2(e.target.value || null)}
                                IconComponent={IoIosArrowDown}
                                fullWidth
                                sx={{
                                    backgroundColor: '#E8E8E8',
                                    '& .MuiOutlinedInput-input': {
                                        padding: '4px 10px',
                                    },
                                    '& .MuiOutlinedInput-notchedOutline': {
                                        border: 'none',
                                    }
                                }}
                            >

                                <MenuItem value="" disabled>
                                    Consultant/Contractor
                                </MenuItem>


                                {
                                    categories.map((item, index) => (
                                        <MenuItem key={index} value={item}>{item}</MenuItem>
                                    ))
                                }
                            </Select>


                            {selectedCategory2 && (
                                <Box
                                    onClick={handleVendorClear}
                                    sx={{
                                        position: 'absolute',
                                        right: '35px',
                                        top: '50%',
                                        transform: 'translateY(-50%)',
                                        cursor: 'pointer',
                                        fontSize: '18px',
                                        color: '#888',
                                        '&:hover': { color: '#000' },
                                        display: { xs: selectedCategory ? 'block' : 'none', md: 'block' },
                                    }}
                                >
                                    &#10005;
                                </Box>
                            )}
                        </Box>

                        <Box sx={{ width: { xs: '100%', sm: '250px', md: '210px' }, }}>
                            <Select
                                value={selectedCategory || ""}
                                onChange={(e) => setSelectedCategory(e.target.value || null)}
                                IconComponent={IoIosArrowDown}
                                sx={{
                                    width: "100%",
                                    backgroundColor: "#E8E8E8",
                                    "& .MuiOutlinedInput-input": {
                                        padding: "5px 15px",
                                    },
                                    "& .MuiOutlinedInput-notchedOutline": {
                                        border: "none",
                                    },
                                }}
                            >
                                {/* <MenuItem value="All Phases">All Phases</MenuItem> */}
                                <MenuItem value="certification" sx={{ fontSize: "16px" }}>Raised to Certified</MenuItem>
                                <MenuItem value="paid">Certified to Paid</MenuItem>
                            </Select>
                        </Box>
                    </Box>
                </Grid2>

            </Grid2>

            <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", height: "100%" }}>
                <Box sx={{ flexShrink: 0 }}>
                    <PieChart highcharts={Highcharts} options={options} />
                </Box>

                <Box sx={{
                    display: "grid",
                    gridTemplateColumns: { xs: "repeat(1, 1fr)", sm: "repeat(3, auto)" },
                    justifyContent: { xs: "start", sm: "center" },
                    gap: 2,
                    mt: 2,
                    px: { xs: 1, sm: 0 },
                    textAlign: { xs: "left", sm: "center" }
                }}>
                    {ageingData.map((val, index) => (
                        <Box key={index} sx={{ display: "flex", alignItems: "center" }}>
                            <FaSquareFull style={{ color: `${val?.color}`, height: "14px", width: "14px", marginRight: "6px" }} />
                            <Typography component="span" sx={{ fontWeight: 500, fontSize: "16px", letterSpacing: "-0.4px", marginRight: 1 }}>
                                {val?.name}:
                            </Typography>
                            <Typography component="span" sx={{ fontWeight: 500, fontSize: "16px", color: "#182A4E" }}>
                                {val?.y}
                            </Typography>
                        </Box>
                    ))}
                </Box>
            </Box>

        </Box>
    );
};

export default AgingAnalysisPaymentTracker;
